<template>
    <div>
        <el-row class="infoLink">
            <router-link to="/my/service/notice">
                <div class="nav-title">
                    {{$t('noticeInfo.noticeNavTitle')}}
                    <i
                        class="navUnRead"
                        v-show="$store.state.noticeUnReadFlag"
                    ></i>
                </div>
            </router-link>
            <router-link to="/my/service/mail">
                <div class="nav-title">
                    {{$t('noticeInfo.messageNavTitle')}}
                    <i
                        class="navUnRead"
                        v-show="$store.state.msgUnReadFlag"
                    ></i>
                </div>
            </router-link>
        </el-row>
        <router-view></router-view>
    </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
    @import url('../../../assets/css/common.css');
.nav-title {
    position: relative;
}
.navUnRead {
    position: absolute;
    right: -0.1rem;
    top: 0.3rem;
    transform: translateY(-50%);
    width: 0.06rem;
    height: 0.06rem;
    border-radius: 50%;
    background-color: #ff3a2b;
}
</style>